import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "components/Layout";
import VoucherBalanceOption from "./VoucherBalanceOption";
import { formatShopPrice } from "constants/shopVouchers";
import {
  checkoutVoucherItems,
  isValidShopEmail,
  readShopBasket,
  readShopGuestEmail,
  writeShopBasket,
  writeShopGuestEmail,
} from "utils/shopBasket";
import "styles/shop.css";

const WarenkorbPage = () => {
  const navigate = useNavigate();
  const token = useSelector((s) => s.token);
  const user = useSelector((s) => s.user);
  const [basket, setBasket] = useState(readShopBasket);
  const [guestEmail, setGuestEmail] = useState(readShopGuestEmail);
  const [status, setStatus] = useState(null);
  const [checkingOut, setCheckingOut] = useState(false);
  const [applyBalance, setApplyBalance] = useState(true);
  const basketTotal = basket.reduce((sum, item) => sum + Number(item.priceCents || 0), 0);
  const balanceCents = token ? Math.max(0, Number(user?.referralBalanceCents || 0)) : 0;

  const updateBasket = (next) => {
    setBasket(writeShopBasket(next));
  };

  const startCheckout = async (items) => {
    if (!token && !isValidShopEmail(guestEmail)) {
      setStatus({ kind: "error", text: "Bitte gib eine gültige E-Mail-Adresse für den Kauf an." });
      return;
    }
    setCheckingOut(true);
    setStatus(null);
    try {
      const result = await checkoutVoucherItems(
        items,
        token ? undefined : guestEmail,
        Boolean(token && applyBalance && balanceCents > 0)
      );
      if (result.url) window.location.href = result.url;
      else navigate(`/shop?order_id=${encodeURIComponent(result.orderId)}`);
    } catch (err) {
      setStatus({
        kind: "error",
        text: err?.response?.data?.message || err?.message || "Der Kauf konnte nicht gestartet werden.",
      });
      setCheckingOut(false);
    }
  };

  return (
    <Layout>
      <section className="shop-page">
        <header className="shop-header">
          <h1>
            Dein <em>Warenkorb</em>
          </h1>
          <p>Hier liegen die Gutscheine, die du noch bezahlen möchtest.</p>
        </header>
        <div className="shop-layout shop-layout--basket">
          <aside className="shop-basket">
            {basket.length === 0 ? (
              <p>
                Noch keine Gutscheine im Warenkorb.{" "}
                <Link to="/shop" className="shop-empty-link">
                  Zum <em>Shop</em>
                </Link>
              </p>
            ) : (
              <ul>
                {basket.map((item) => (
                  <li key={item.localId}>
                    <div>
                      <strong>{item.label}</strong>
                      <span>{formatShopPrice(item.priceCents)}</span>
                      {item.recipientEmail && <small>Geschenk an {item.recipientEmail}</small>}
                    </div>
                    <button
                      type="button"
                      onClick={() =>
                        updateBasket(basket.filter((entry) => entry.localId !== item.localId))
                      }
                    >
                      Entfernen
                    </button>
                  </li>
                ))}
              </ul>
            )}
            <p className="shop-basket-total">
              <span>Gesamt</span>
              <strong>{formatShopPrice(basketTotal)}</strong>
            </p>
            <VoucherBalanceOption
              totalCents={basketTotal}
              balanceCents={balanceCents}
              checked={applyBalance}
              onChange={setApplyBalance}
            />
            {!token && basket.length > 0 && (
              <label className="shop-field">
                Deine E-Mail-Adresse für die Kaufbestätigung
                <input
                  type="email"
                  value={guestEmail}
                  placeholder="name@example.com"
                  autoComplete="email"
                  onChange={(event) => {
                    setGuestEmail(event.target.value);
                    writeShopGuestEmail(event.target.value);
                  }}
                />
              </label>
            )}
            {status && <div className={`auth-alert is-${status.kind}`}>{status.text}</div>}
            <button
              type="button"
              className="btn-primary"
              disabled={!basket.length || checkingOut}
              onClick={() => startCheckout(basket)}
            >
              {checkingOut ? "Weiterleitung…" : "Warenkorb bezahlen"}
            </button>
          </aside>
        </div>
      </section>
    </Layout>
  );
};

export default WarenkorbPage;
